import React from "react";
import { motion } from "framer-motion/dist/framer-motion";
import { staticBounceVariants } from "shared/components/animations";
const DWInfoCard = ({ info1 = "", info2 = "", styled_info3 = "" }) => {
  return (
    <motion.div variants={staticBounceVariants} className="info-card">
      <h3 className="title">{info1}</h3>
      <p className="info">{info2}</p>
      <p className="info2">{styled_info3}</p>
    </motion.div>
  );
};

export default DWInfoCard;
